import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const CustomControllerNamePropsSchema = z.object({
  customControllerNameValue: z.string(),
})

type CustomControllerNameProps = z.infer<typeof CustomControllerNamePropsSchema>

export class CustomControllerName extends ValueObject<CustomControllerNameProps> {
  public getValue(): string {
    return this.props.customControllerNameValue
  }

  public static create(props: CustomControllerNameProps): CustomControllerName {
    const validatedProps = CustomControllerNamePropsSchema.parse(props)
    return new CustomControllerName(validatedProps)
  }
}
